import CustomToast from "../../utils/functions/CustomToast";
import HttpClient from "../../utils/functions/HttpClient";
import ServerEndpoints from "../../utils/constants/ServerEndpoints";

/**
 * Fetch all contact inquiries with pagination and optional status filter.
 */
export const getAllInquiries = async (setData, params, setIsLoading) => {
  try {
    const response = await HttpClient.getAxiosClient().get(
      `${ServerEndpoints.ADMIN_CONTACT_ENDPOINT}`,
      { params }
    );
    if (response.status === 200) {
      setData(response.data);
    }
  } catch (err) {
    const status = err?.response?.status;
    if (status === 503) {
      CustomToast("Service currently unavailable, please try again later.", "error");
    } else {
      CustomToast("Failed to load inquiries.", "error");
    }
  } finally {
    setIsLoading(false);
  }
};

/**
 * Update the status of a contact inquiry.
 * @param {number} id The inquiry ID
 * @param {string} status The new status (NEW, READ, RESPONDED, CLOSED)
 * @param {Function} onSuccess Callback on success
 * @param {Function} setIsLoading Loading state setter
 */
export const updateInquiryStatus = async (id, status, onSuccess, setIsLoading) => {
  try {
    setIsLoading(true);
    const response = await HttpClient.getAxiosClient().put(
      `${ServerEndpoints.ADMIN_CONTACT_ENDPOINT}/${id}/status`,
      null,
      { params: { status } }
    );
    if (response.status === 200) {
      CustomToast(`Inquiry marked as ${status}`, "success");
      onSuccess();
    }
  } catch (err) {
    const status = err?.response?.status;
    if (status === 400) {
      CustomToast("Invalid status value.", "error");
    } else if (status === 404) {
      CustomToast("Inquiry not found.", "error");
    } else {
      CustomToast("Failed to update inquiry status.", "error");
    }
  } finally {
    setIsLoading(false);
  }
};

/**
 * Reply to a contact inquiry. Sends the reply email and marks as RESPONDED.
 * @param {number} id The inquiry ID
 * @param {string} message The reply message
 * @param {string} adminName The admin's display name
 * @param {Function} onSuccess Callback on success
 * @param {Function} setIsLoading Loading state setter
 */
export const replyToInquiry = async (id, message, adminName, onSuccess, setIsLoading) => {
  try {
    setIsLoading(true);
    const response = await HttpClient.getAxiosClient().post(
      `${ServerEndpoints.ADMIN_CONTACT_ENDPOINT}/${id}/reply`,
      { message, adminName }
    );
    if (response.status === 200) {
      CustomToast("Reply sent successfully!", "success");
      onSuccess();
    }
  } catch (err) {
    const errStatus = err?.response?.status;
    if (errStatus === 400) {
      CustomToast("Reply message cannot be empty.", "error");
    } else if (errStatus === 404) {
      CustomToast("Inquiry not found.", "error");
    } else {
      CustomToast("Failed to send reply.", "error");
    }
  } finally {
    setIsLoading(false);
  }
};
